import { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import { ROUTES } from 'src/constants'
import { SearchBar } from '../search-bar'
import { RoutesButtons } from '../routes-buttons'
import { joinAbsRoute } from 'src/common/utils'
import { ETranslationNs } from 'src/types'

export const AdminRoutes = () => {
  const [t] = useTranslation([ETranslationNs.Navbar])

  const [searchvalue, setSearchValue] = useState('')

  const routes = [
    {
      primary: t('accounts-all-header-title.v'),
      link: joinAbsRoute(ROUTES.ACCOUNTS_ALL),
    },
    {
      primary: t('products-all-header-title.v'),
      link: joinAbsRoute(ROUTES.PRODUCTS_ALL),
    },
    {
      primary: t('users-all-header-title.v'),
      link: joinAbsRoute(ROUTES.USERS),
    },
    {
      primary: t('impacts-library-header-title.v'),
      link: joinAbsRoute(ROUTES.IMPACTS_LIBRARY),
    },
    {
      primary: t('logs-header-title.v'),
      link: joinAbsRoute(ROUTES.CHANGES),
    },
    {
      primary: t('languages-navbar-title.v'),
      link: joinAbsRoute(ROUTES.LANGAUGE_TRANSLATIONS),
    },
    {
      primary: t('login-types-header-title.v'),
      link: joinAbsRoute(ROUTES.LOGIN_TYPES),
    },
    {
      primary: t('white-label-partners-header-title.v'),
      link: joinAbsRoute(ROUTES.WHITE_LABEL_PARTNERS),
    },
    {
      primary: t('scan-history-header-title.v'),
      link: joinAbsRoute(ROUTES.SCAN_HISTORY),
    },
    {
      primary: t('settings-header-title.v'),
      link: joinAbsRoute(ROUTES.SETTINGS),
    },
    {
      primary: t('media-vault-header-title.v'),
      link: joinAbsRoute(ROUTES.MEDIA_VAULT),
    },
    {
      primary: t('account-industries-header-title.v'),
      link: joinAbsRoute(ROUTES.ACCOUNT_INDUSTRIES),
    },
    {
      primary: t('subscription-prices-header-title.v'),
      link: joinAbsRoute(ROUTES.SUBSCRIPTION_PRICES),
    },
    {
      primary: t('reward-points-header-title.v'),
      link: joinAbsRoute(ROUTES.REWARD_POINTS),
    },
    {
      primary: t('decline-reasons-header-title.v'),
      link: joinAbsRoute(ROUTES.DECLINE_REASONS),
    },
    {
      primary: t('approval-feedbacks-header-title.v'),
      link: joinAbsRoute(ROUTES.APPROVAL_FEEDBACKS),
    },
    {
      primary: t('third-party-api-header-title.v'),
      link: joinAbsRoute(ROUTES.HEALTH_CHECK),
    },
    {
      primary: t('redirect-urls-api-header-title.v'),
      link: joinAbsRoute(ROUTES.REDIRECT_URLS),
    },
    {
      primary: t('cron-jobs-header-title.v'),
      link: joinAbsRoute(ROUTES.CRON_JOBS),
    },
    {
      primary: t('rating-settings-header-title.v'),
      link: joinAbsRoute(ROUTES.RATING_SETTINGS),
    },
    {
      primary: t('admin-scan-to-earn-management-header-title.v'),
      link: joinAbsRoute(ROUTES.SCAN_TO_EARN_MANAGEMENT),
    },
    {
      primary: t('admin-challenges-management-header-title.v'),
      link: joinAbsRoute(ROUTES.CHALLENGES),
    },
    {
      primary: t('admin-tools-header-title.v'),
      link: joinAbsRoute(ROUTES.ADMIN_TOOLS),
    },
    {
      primary: t('x-rate-limits-header-title.v'),
      link: joinAbsRoute(ROUTES.X_RATE_LIMITS),
    },
  ]

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value

    setSearchValue(query)
  }

  // Filter and sort routes
  const filteredRoutes = routes
    .filter((route) => route.primary.toLowerCase().includes(searchvalue.toLowerCase()))
    .sort((a, b) => a.primary.localeCompare(b.primary))

  return (
    <>
      <Box sx={{ mb: '25px', mt: '25px' }}>
        <SearchBar handleSearchChange={handleSearchChange} search={searchvalue} autoFocus />
      </Box>
      <RoutesButtons items={filteredRoutes} />
    </>
  )
}
